// extracted by mini-css-extract-plugin
module.exports = {"main":"ErrorFallback_main__1kDhq","content":"ErrorFallback_content__3zmpt","title":"ErrorFallback_title__gFNRJ"};